import React from 'react';
import { InfoCard, StructuredMetadataTable } from '@backstage/core-components';
import { ArgusEnv } from '@eng-portal/plugin-argus-common';
import { omit } from 'lodash';
import DnsIcon from '@mui/icons-material/Dns';


type EnvCardProps = {
  env: ArgusEnv
  useUtc?: boolean
};

export function EnvCard({ env, useUtc }: EnvCardProps): JSX.Element {
  const processedEnv = omit(env, 'update_time') as ArgusEnv;

  if (useUtc && processedEnv.create_time) {
    processedEnv.create_time = new Date(processedEnv.create_time).toISOString();
  } else if (processedEnv.create_time) {
    processedEnv.create_time = new Date(processedEnv.create_time).toLocaleString();
  }

  return (
    <InfoCard title="Env" headerProps={{ avatar: <DnsIcon /> }}>
      <StructuredMetadataTable metadata={processedEnv} />
    </InfoCard>
  );
}
